import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Input, Label } from 'reactstrap';
import { connect } from 'react-redux';

import AdminEditButtons from '../EditButtons';
import ErrorBoundary from '../../ErrorBoundary';

const AdminTaxonomyEditMetadataGroups = ({
  entity,
  entityId,
  handleDelete,
  metadataGroups,
  handleChangeMetadataGroups,
  ...props
}) => {
  const intl = useIntl();

  const [assignedGroups, setAssignedGroups] = useState([]);

  const isAssigned = (tg) => assignedGroups.includes(tg.id);

  const toggleAssignment = (tg) => {
    setAssignedGroups(
      (prev) => (isAssigned(tg) ? prev.filter((id) => id !== tg.id) : [...prev, tg.id]),
    );
  };

  useEffect(() => {
    handleChangeMetadataGroups(assignedGroups);
  }, [handleChangeMetadataGroups, assignedGroups]);

  useEffect(() => {
    setAssignedGroups(entity.metadata_groups);
  }, [entity]);

  return (
    <ErrorBoundary>
      <div className="tab-content-wrapper">
        <div>
          <p>
            {intl.formatMessage({ defaultMessage: 'Assign to Metadata Groups.' })}
          </p>
        </div>
        <div>
          {metadataGroups.length === 0 && (
            intl.formatMessage({ defaultMessage: 'No Metadata Groups to associate.' })
          )}
          {metadataGroups.length > 0 && (
            <div className="metadata-group-to-assign">
              {metadataGroups.map((tg) => (
                <Label
                  for={`metadata-group-to-assign-${tg.id}`}
                  key={`metadata-group-to-assign-${tg.id}`}
                  className="metadata-group-to-assign-element"
                >
                  <div
                    className="metadata-group-to-assign-label"
                  >
                    <Input
                      className="input-check check-s form-check-input"
                      id={`metadata-group-to-assign-${tg.id}`}
                      type="checkbox"
                      checked={isAssigned(tg)}
                      onChange={() => toggleAssignment(tg)}
                    />
                    <span>
                      {tg.name}
                    </span>
                  </div>
                  <span />
                </Label>
              ))}
            </div>
          )}
        </div>
      </div>
      <AdminEditButtons
        {...props}
        deleteText={intl.formatMessage({ defaultMessage: 'Delete Tag Category' })}
        hideDelete={entityId === null}
        handleDelete={handleDelete}
      />
    </ErrorBoundary>
  );
};

const mapStateToProps = state => ({
  metadataGroups: state.Metadata.metadataGroups,
});

AdminTaxonomyEditMetadataGroups.propTypes = {
  metadataGroups: PropTypes.array.isRequired,
  entity: PropTypes.object,
  entityId: PropTypes.string,
  handleChangeMetadataGroups: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
};

AdminTaxonomyEditMetadataGroups.defaultProps = {
  entity: null,
  entityId: null,
};

export default connect(mapStateToProps)(AdminTaxonomyEditMetadataGroups);
